module.exports = __webpack_public_path__ + "img/illustration_por.2cefea12.png";